import controller from "emun.cust/locations/ship-location-container.controller";
import templateUrl from "emun.cust/locations/ship-location-container.htm";

export default {
  bindings: {
    ngModel: "=?",
    retailerId: "@",
    customerId: "@",
    status: "@",
    pending: "<?",
    layout: "@",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
